import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { CONTACT_CONFIG } from '../config/contact';

export default function Use() {
  // Utilisation des variables de configuration centralisées
  const contactInfo = CONTACT_CONFIG;
  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Términos y Condiciones</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
              >
                Inicio
              </NavLink>{" "}
              / <span className="text-gray-300">Términos y Condiciones</span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Aceptación de los términos
              </h2>
              <p className="text-base leading-relaxed">
                Al acceder a nuestro sitio web y utilizar nuestros servicios IPTV,
                usted acepta estos Términos y Condiciones. Si no está
                de acuerdo con estos términos, por favor no utilice nuestro sitio o
                nuestros servicios.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">2. Servicios IPTV</h2>
              <p className="text-base leading-relaxed">
                TVDIAMO ofrece suscripciones IPTV para permitirle
                disfrutar de una gran variedad de canales y contenido. Estas
                suscripciones están diseñadas para ofrecer una experiencia de
                visualización de calidad sin necesidad de recopilar su
                información personal.
                <br />
                Los códigos de activación y las instrucciones de instalación le
                serán proporcionados inmediatamente después de su compra.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">3. Privacidad</h2>
              <p className="text-base leading-relaxed">
                No recopilamos ningún dato personal de nuestros
                usuarios. Esto significa que su nombre, dirección, información
                de pago o cualquier otro detalle identificable no son
                recopilados ni almacenados por TVDIAMO. Su privacidad está
                garantizada, y hemos implementado medidas para evitar
                cualquier recopilación de datos por terceros.
              </p>
              <p className="text-base leading-relaxed pt-2">
                Al utilizar nuestros servicios, puede estar seguro de que sus
                actividades permanecen completamente anónimas y seguras.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">4. Pago</h2>
              <p className="text-base leading-relaxed">
                Los pagos se realizan a través de plataformas seguras de
                terceros. TVDIAMO no almacena ninguna información de pago.
                Por favor, siga las instrucciones proporcionadas para finalizar su
                compra de forma segura.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                5. Uso de los servicios
              </h2>
              <p className="text-base leading-relaxed">
                Los servicios IPTV proporcionados por TVDIAMO están destinados únicamente a
                un uso personal. No debe compartir, redistribuir o
                revender los códigos de activación o el contenido proporcionado por nuestros
                servicios. Cualquier uso indebido puede resultar en la
                terminación de su suscripción sin reembolso.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">6. Responsabilidad</h2>
              <p className="text-base leading-relaxed">
                TVDIAMO se compromete a proporcionar servicios IPTV de alta calidad.
                Sin embargo, no podemos garantizar una disponibilidad
                ininterrumpida debido a factores externos como cortes
                de Internet o problemas técnicos. Declinamos toda
                responsabilidad por interrupciones fuera de nuestro
                control.
              </p>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                7. Derechos de propiedad intelectual
              </h2>
              <p className="text-base leading-relaxed">
                Todo el contenido proporcionado por nuestros servicios IPTV, incluidos los
                canales, películas y series, está protegido por derechos de autor y
                leyes de propiedad intelectual. No debe
                grabar, distribuir o copiar este contenido.
              </p>
            </div>

            {/* Section 8 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                8. Modificaciones de los términos
              </h2>
              <p className="text-base leading-relaxed">
                Nos reservamos el derecho de modificar estos términos en cualquier
                momento. Cualquier modificación será publicada en nuestro sitio web. Al
                continuar utilizando nuestros servicios después de una modificación, usted
                acepta las nuevas condiciones.
              </p>
            </div>

            {/* Section 9 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">9. Contáctenos</h2>
              <p className="text-base leading-relaxed mb-4">
                Para cualquier pregunta sobre estos términos y condiciones o para ejercer
                sus derechos, puede contactarnos a través de:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>Email : {contactInfo.email}</li>
                <li>
                  WhatsApp :{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Haga clic aquí para contactarnos
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Gracias por elegir {contactInfo.companyName}. Estamos orgullosos de garantizar
                su privacidad y ofrecerle un servicio de alta
                calidad sin comprometer su seguridad o su anonimato.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
